<template>
    <div class="card-body">
        <form @submit.prevent="$emit('getReport')">
            <div class="row">
                <div :class="['col-12 col-md-12', (typeInvoiceMySelf) ? 'col-lg-4 col-xl-4' : 'col-lg-6 col-xl-6' ]">
                    <b-form-group :label="((typeInvoice) ? 'วันที่ออกใบแจ้งหนี้ ' : 'วันที่ออกใบเสร็จ ' )+'(วันเริ่มต้น - วันสุดท้าย)'" class="mb-0" >
                        <date-range-picker
                            class="w-100"
                            @start-selection="logEvent('startSelection', $event)"
                            @finish-selection="logEvent('finishSelection', $event)"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :opens="'center'"
                            :singleDatePicker="false"
                            :appendToBody="true"
                            :ranges="false"
                            :closeOnEsc="false"
                            :autoApply="true"
                            :locale-data="{ format: 'dd/mm/yyyy' }"
                            v-model="search.date"
                        >
                        </date-range-picker>
                    </b-form-group>
                </div>
                <template v-if="!this.$USER_LOGIN.get().isAdmin &&  (typeInvoice)">
                    <div class="col-12 col-md-12 4 col-xl-3">
                        <b-form-group
                            label="สถานะใบแจ้งหนี้"
                            class="mb-0"
                        >
                            <v-select    
                                label="title"
                                :options="listStatusInvoice"
                                v-model="search.status"
                                :reduce="statusInvoice => statusInvoice.key"
                            >
                            </v-select>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-12 col-lg-3 col-xl-3">
                        <label>ประเภทการชำระเงิน</label>
                        <v-select
                            :options="listPaymentType"
                            label="title"
                            placeholder="ประเภทการชำระเงิน"
                            v-model="search.paymentType"
                            :reduce="paymentType => paymentType.key"
                        ></v-select>
                    </div>
                    <div class="col-12 col-md-12 col-lg-4 col-xl-4 pt-2" v-if="this.$USER_LOGIN.get().isShippop">
                        <label>รายชื่อ Super Admin</label>
                        <v-select
                            :options="listAgent"
                            label="name"
                            placeholder="รายชื่อ Super Admin"
                            v-model="search.saCode"
                            :reduce="selectAgent => selectAgent.dealer_id"
                        >
                            <template v-slot:option="option">
                                <span>{{ option.dealer_id }} ( {{option.name}} )</span>
                            </template>
                        </v-select>
                    </div>
                    <div :class="['col-12 col-md-12 pt-2', (this.$USER_LOGIN.get().isShippop) ? 'col-lg-4 col-xl-4' : 'col-lg-5 col-xl-5' ]">
                        <label>รายชื่อร้านค้า</label>
                        <v-select
                            :options="listShop"
                            label="name"
                            placeholder="รายชื่อร้านค้า"
                            v-model="search.shopCode"
                            :reduce="selectShop => selectShop.shop_code"
                        >
                            <template v-slot:option="option">
                                <span>{{ option.shop_code }} ( {{option.name}} )</span>
                            </template>
                        </v-select>
                    </div>
                    <div :class="['col-12 col-md-12 pt-1', (this.$USER_LOGIN.get().isShippop) ? 'col-lg-3 col-xl-3' : 'col-lg-6 col-xl-6' ]">
                        <b-form-group
                            label="ค้นหาด้วยเลขที่ใบแจ้งหนี้"
                            class="mb-0"
                        >
                            <b-form-input
                                type="text"
                                placeholder="ค้นหาด้วยเลขที่ใบแจ้งหนี้"
                                v-model="search.invoiceNo"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </template>
                <template v-else-if="typeInvoiceMySelf">
                    <div class="col-12 col-md-12 col-lg-3 col-xl-3">
                        <b-form-group
                            label="สถานะใบแจ้งหนี้"
                            class="mb-0"
                        >
                            <v-select    
                                label="title"
                                :options="listStatusInvoice"
                                v-model="search.status"
                                :reduce="statusInvoice => statusInvoice.key"
                            >
                            </v-select>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-12 col-lg-4 col-xl-4">
                        <b-form-group
                            label="ค้นหาด้วยเลขที่ใบแจ้งหนี้"
                            class="mb-0"
                        >
                            <b-form-input
                                type="text"
                                placeholder="ค้นหาด้วยเลขที่ใบแจ้งหนี้"
                                v-model="search.invoiceNo"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </template>
                <!-- <template v-else-if="!this.$USER_LOGIN.get().isAdmin && !(typeInvoice)">
                    <div class="col-12 col-md-12 col-lg-6 col-xl-6 pt-1" v-if="this.$USER_LOGIN.get().isShippop">
                        <label>รายชื่อ Super Admin</label>
                        <v-select
                            :options="listAgent"
                            label="name"
                            placeholder="รายชื่อ Super Admin"
                            v-model="search.saCode"
                            :reduce="selectAgent => selectAgent.dealer_id"
                        >
                            <template v-slot:option="option">
                                <span>{{ option.dealer_id }} ( {{option.name}} )</span>
                            </template>
                        </v-select>
                    </div>
                    <div :class="['col-12 col-md-12', (this.$USER_LOGIN.get().isShippop) ? 'col-lg-4 col-xl-4 pt-2' : 'col-lg-6 col-xl-6 pt-1' ]">
                        <label>รายชื่อร้านค้า</label>
                        <v-select
                            :options="listShop"
                            label="name"
                            placeholder="รายชื่อร้านค้า"
                            v-model="search.shopCode"
                            :reduce="selectShop => selectShop.shop_code"
                        >
                            <template v-slot:option="option">
                                <span>{{ option.shop_code }} ( {{option.name}} )</span>
                            </template>
                        </v-select>
                    </div>
                    <div :class="['col-12 col-md-12 pt-1', (this.$USER_LOGIN.get().isShippop) ? 'col-lg-3 col-xl-3' : 'col-lg-6 col-xl-6' ]">
                        <label>ประเภทการชำระเงิน</label>
                        <v-select
                            :options="listPaymentType"
                            label="title"
                            placeholder="ประเภทการชำระเงิน"
                            v-model="search.paymentType"
                            :reduce="paymentType => paymentType.key"
                        ></v-select>
                    </div>
                    <div :class="['col-12 col-md-12 pt-1', (this.$USER_LOGIN.get().isShippop) ? 'col-lg-4 col-xl-4' : 'col-lg-5 col-xl-5' ]">
                        <b-form-group
                            label="ค้นหาด้วยเลขที่ใบเสร็จ"
                            class="mb-0"
                        >
                            <b-form-input
                                type="text"
                                placeholder="ค้นหาด้วยเลขที่ใบเสร็จ"
                                v-model="search.receiptNo"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </template> -->
                <div class="col-12 col-md-12 col-lg-1 col-xl-1 d-flex align-items-end pt-4">
                    <b-button type="submit" variant="info" block>
                        <i class="fas fa-circle-notch fa-spin" v-if="search.isLoading"></i>
                        <i class="fa fa-search" v-else></i>
                    </b-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import moment from 'moment'
import { dateLimitRanges } from "@/plugins/datePicker.js"
import { getListShop } from "@/axios/shop.js";
import { getListAgent } from "@/axios/agent.js";
import { showErrorModal } from "@/components/modalNotification.js"; 

export default {
    props:{
        search: Object,
        type: String
    },
    data(){
        return{    
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            listPaymentType:[
                { key: null , title: 'ทั้งหมด'},
                { key: 'MONTHLY' , title: 'รายเดือน'},
                { key: 'DAILY' , title: 'รายวัน'},
                { key: 'WEEKLY' , title: 'รายสัปดาห์'},
            ],
            listStatusInvoice:[
                { key: null , title: 'ทั้งหมด'},
                { key: 'UNPAID' , title: 'รอชำระเงิน'},
                { key: 'PAID' , title: 'ชำระแล้ว'},
            ],
            listShop: [ {shop_code:null , name:"ดูทั้งหมด"} ],
            listAgent: [ {dealer_id: null , name: 'ดูทั้งหมด'} ]
        }
    },
    mounted() {
        this.defaultLoad()
    },
    methods:{
        defaultLoad(){
            if( !this.$USER_LOGIN.get().isAdmin ){
                getListShop(true).then( shop => {
                    this.listShop = [ ...this.listShop , ...shop];
                }).catch( error => {
                    showErrorModal( error )
                })

                if( !this.$USER_LOGIN.get().isSuperadmin ){
                    getListAgent().then( agent => {
                        this.listAgent = [ ...this.listAgent , ...agent];
                    })
                }

            }
        },
        logEvent( event , date ){
            const { minDate , maxDate } = dateLimitRanges(event, date);
            this.minDate = minDate
            this.maxDate = maxDate
        },
    },
    computed:{
        typeInvoice(){
            return this.type === "INVOICE"
        },
        typeInvoiceMySelf(){
            return this.type === "INVOICE_SELF"
        }
    }
}
</script>